<template>
  <div class="aviso-listagem">
    <slot />
  </div>
</template>
<script setup></script>
<style scoped>
.aviso-listagem {
  text-align: center;
  padding: 30px;
  font-size: 1.1em;
  color: #666;
  background-color: #f9f9f9;
  border-radius: 10px;
  border: 1px dashed #ccc;
  margin-top: 20px;
}
</style>
